import * as React from 'react';
import * as classnames from 'classnames';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import { Button } from 'elc-buttons';
import { ContentSpacing } from 'elc-base-theme';
import { observable } from 'mobx';

export interface IAddToCollectionConfig {
    isDisabled?: boolean;
    addToCollectionDataTestId?: string;
    initialStateLabel?: string;
    clickedStateLabel?: string;
}

export interface IAddToCollectionButton {
    onAddToCollectionClick(): void;
    config: IAddToCollectionConfig;
}

const StyledButton = styled(Button)`
    margin-right: ${ContentSpacing.space16};
    height: 40px;

    [dir='rtl'] & {
        margin-left: ${ContentSpacing.space16};
        margin-right: 0;
    }
`;

@observer
export class AddToCollectionButton extends React.Component<IAddToCollectionButton> {
    @observable private buttonLabel = this.props.config.initialStateLabel;

    private onAddToCollectionClick = () => {
        this.props.onAddToCollectionClick();
        this.buttonLabel = this.props.config.clickedStateLabel;
    };

    public render() {
        const { isDisabled, addToCollectionDataTestId } = this.props.config;

        const addToCollectionButtonClassNames = classnames(
            'elc-add-to-collection-button',
            'js-add-to-collection-button',
            {
                'elc-add-to-collection-button-disabled': isDisabled,
                'js-add-to-collection-button-disabled': isDisabled
            }
        );

        return (
            <StyledButton
                className={addToCollectionButtonClassNames}
                aria-label={this.buttonLabel}
                title={this.buttonLabel}
                disabled={isDisabled}
                data-test-id={
                    addToCollectionDataTestId ? addToCollectionDataTestId : 'add_to_collection_btn'
                }
                onClick={this.onAddToCollectionClick}
            >
                {this.buttonLabel}
            </StyledButton>
        );
    }
}
